<script setup>
import { ref, computed, defineAsyncComponent } from 'vue'
import { useGlobalStore } from '@stores/global.js'
const global = useGlobalStore()

const modal = ref()
const loadModal = (name) => {
	return defineAsyncComponent(() => import(`@components/global/modals/${name}.vue`))
}
const modalComponent = computed(() => loadModal(global.modal.name))
</script>

<template>
	<div class="fixed z-50 flex h-full w-full items-center justify-center">
		<div class="relative z-50 mx-5 w-full max-w-screen-md overflow-y-auto rounded-md bg-logi-grey-400 p-5 py-7 lg:p-8" style="max-height: calc(100dvh - 2.5rem)">
			<transition name="fade" mode="out-in">
				<button class="absolute right-5 top-5 flex h-10 w-10 items-center justify-center" @click="global.closeModal()" aria-label="Close Modal" aria-controls="modal" tabindex="0" v-if="global.modal.canClose">
					<i class="fas fa-xmark text-2xl" />
				</button>
			</transition>
			<component :is="modalComponent" ref="modal" />
		</div>
		<!-- <div class="absolute left-0 top-0 h-full w-full bg-black/50 backdrop-blur-xs" @click="global.closeModal()"></div> -->
		<div class="absolute left-0 top-0 h-full w-full bg-black/50 backdrop-blur-xs"></div>
	</div>
</template>
